var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoClosed = function SvgLogoClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Logo-Closed_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#000",
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Logo-Closed_svg__b)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -30.715,
    cy: -47,
    fill: "#fff",
    fillOpacity: 0.5,
    rx: 108.531,
    ry: 56.053,
    transform: "rotate(-23.738 -30.715 -47)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14.019 19.895c.362-.42.9-.664 1.466-.664h7.697c2.109 0 3.818-1.653 3.818-3.693v-1.846C27 11.653 25.29 10 23.182 10H21.69c-.567 0-1.104.243-1.467.664l-1.241 1.441c-.363.42-.9.664-1.467.664H9.818C7.71 12.77 6 14.422 6 16.462v1.846C6 20.347 7.71 22 9.818 22h1.492c.567 0 1.104-.243 1.467-.664zm10.117-6.203c0-.51-.427-.923-.954-.923h-2.924c-.567 0-1.104.244-1.467.665l-1.241 1.44c-.363.421-.9.665-1.467.665H9.818c-.527 0-.954.413-.954.923v1.846c0 .51.427.923.954.923h2.924c.567 0 1.104-.244 1.467-.665l1.241-1.44c.363-.421.9-.665 1.467-.665h6.265c.527 0 .954-.413.954-.922z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Logo-Closed_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff",
    rx: 6
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Logo-Closed_svg__b",
    width: 323.803,
    height: 254.785,
    x: -192.616,
    y: -174.392,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_428_30516",
    stdDeviation: 30
  })))));
};
export default SvgLogoClosed;